import { DOMAIN_API_URL, ENV, ResponseData } from "src/constant";
import { buildURLWithParam, extend } from ".";

export function fetch(
    url,
    params?: {},
    options?: {},
    timeOut?: 10
): Promise<ResponseData<any>> {
    //   const auth =
    //     "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJlcnVrbnBkOXY0IiwiZXhwIjozMjkwNTM2MTcyfQ.D38sJlqeNp6YGlT-0ZvoNAgtpVDBhPlqbdTCVkHlml8";
    const exOptions = extend(
        {
            //credentials: ENV.LOCAL ? "include" : "same-origin",
            credentials: ENV.LOCAL ? "include" : "same-origin",
            headers: { "Content-Type": "application/json" },
            // mode: 'no-cors'
        },
        options
    );

    var fullUrl = url;
    if (params) {
        fullUrl = buildURLWithParam(url, params);
    }

    return window
        .fetch(fullUrl, exOptions)
        .then(toJson)
        .then(validResp);
}

export const get = (
    url: string,
    params?: {},
    options?: {},
    timeOut?: 10
) => {
    const exOptions = extend(
        {
            method: 'GET',
            // redirected: 'true',
        },
        options
    );
    return fetch(url, params, exOptions, timeOut);
};

export const getWithPath = (path, params?: {}, options?: {}, timeOut?: 10) => {
    return getWithUrl(DOMAIN_API_URL + path, params, options, timeOut);
};

export const getWithLocalPath = (
    path,
    params?: {},
    options?: {},
    timeOut?: 10
) => {
    return getWithUrl(
        "http://localhost:3000/api" + path,
        params,
        options,
        timeOut
    );
};

export const getWithUrl = (
    url: string,
    params?: {},
    options?: {},
    timeOut?: 10
) => {
    return fetch(url, params, options, timeOut);
};

export const getUrlFromPath = (path, params) => {
    return buildURLWithParam(DOMAIN_API_URL + path, params);
};

export const post = (
    url,
    params = {},
    data: any = {},
    options: any = {},
    timeOut
) => {
    return fetch(
        url,
        params,
        extend(
            {
                body: JSON.stringify(data),
            },
            options
        ),
        timeOut
    );
};

export const postWithUrlBinary = (
    url,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    return fetch(
        url,
        params,
        extend({ body: formData, method: "POST" }, options),
        timeOut
    );
};

export const postWithPath = (
    path,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return postWithUrl(DOMAIN_API_URL + path, params, data, options, timeOut);
};

export const putWithPath = (
    path,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return putWithUrl(DOMAIN_API_URL + path, params, data, options, timeOut);
};

export const postWithPathBinary = (
    path,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return postWithUrlBinary(
        DOMAIN_API_URL + path,
        params,
        data,
        options,
        timeOut
    );
};

export const postWithUrl = (
    url,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return post(url, params, data, extend({ method: "POST" }, options), timeOut);
};

export const putWithUrl = (
    url,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return post(url, params, data, extend({ method: "PUT" }, options), timeOut);
};

export const deleteWithPath = (
    path,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return deleteWithUrl(DOMAIN_API_URL + path, params, data, options, timeOut);
};

export const deleteWithUrl = (
    url,
    params?: {},
    data?: {},
    options?: {},
    timeOut?: 10
) => {
    return post(
        url,
        params,
        data,
        extend({ method: "DELETE" }, options),
        timeOut
    );
};

function toJson(resp) {
    if (resp.ok) {
        return resp.json();
    }

    return Promise.reject(resp);
}

function validResp<T>(resp: ResponseData<T>): Promise<ResponseData<T>> {
    if (!resp || resp.code < 0) {
        return Promise.reject(resp);
    }
    return Promise.resolve(resp);
}
